import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import benchSvg from 'assets/img/production-output/bench.svg';
import {
  formatValue,
  getMetricLabel,
  machineAssetMap,
  stationShape
} from './outputPerformanceShared';
import { BreakdownList } from './StationEntry';

export function OutputDetailModal({ detail, factoryName, onHide }) {
  const show = Boolean(detail);
  const station = detail?.station;
  const stationIcon = station
    ? machineAssetMap[station.displayType] || benchSvg
    : null;

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {detail
            ? `${factoryName} / ${detail.areaName} / ${detail.groupName}`
            : 'Output Performance'}
        </Modal.Title>
      </Modal.Header>
      {detail && station && (
        <Modal.Body>
          <div className="output-detail-summary">
            <div className="output-detail-media">
              <img src={stationIcon} alt={station.name} />
            </div>
            <div>
              <div className="output-detail-label">{station.name}</div>
              <div className="output-detail-path">
                {station.stationPath || 'no-path'}
              </div>
              {!station.isResolved && station.resolutionNote && (
                <div className="output-detail-unresolved-note">
                  {station.resolutionNote}
                </div>
              )}
              <div className="output-detail-label">Total Output</div>
              <div className="output-detail-total">
                {formatValue(station.total)}
              </div>
              {station.hasWeldedCillData && (
                <div className="output-detail-boxes">
                  <div>
                    <span>Boxes created</span>
                    <strong>{formatValue(station.weldedCillBoxesCreated)}</strong>
                  </div>
                  <div>
                    <span>
                      {station.weldedCillFacetsLabel
                        ? `Total ${station.weldedCillFacetsLabel.toLowerCase()}`
                        : 'Total facets'}
                    </span>
                    <strong>{formatValue(station.weldedCillTotalFacets)}</strong>
                  </div>
                </div>
              )}
              {station.hasBoxData && (
                <div className="output-detail-boxes">
                  <div>
                    <span>Items packed</span>
                    <strong>{formatValue(station.itemsCount)}</strong>
                  </div>
                  <div>
                    <span>Boxes created</span>
                    <strong>{formatValue(station.boxesCount)}</strong>
                  </div>
                </div>
              )}
              {station.itemTypeBreakdown?.length > 0 && (
                <div className="output-detail-item-type-breakdown">
                  <div className="output-detail-item-type-title">By item type</div>
                  <ul className="output-item-type-list">
                    {station.itemTypeBreakdown.map(item => (
                      <li key={item.name} className="output-item-type-row">
                        <span className="output-item-type-name">{item.name}</span>
                        <strong className="output-item-type-value">
                          {formatValue(item.value)}
                        </strong>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="output-detail-station-count">
              {getMetricLabel(station.metricType)}
            </div>
          </div>

          <div className="output-detail-breakdowns">
            <BreakdownList title="Shift Breakdown" items={station.shiftBreakdown} />
            <BreakdownList title="People Breakdown" items={station.peopleBreakdown} />
          </div>

          <div className="output-detail-groups">
            <div className="output-detail-group">
              <div>
                <div className="output-detail-group-title">{station.name}</div>
                <div className="output-detail-group-stations">
                  {detail.areaName} / {detail.groupName}
                </div>
              </div>
              <div className="output-detail-group-value">
                <strong>{formatValue(station.total)}</strong>
                <span>{getMetricLabel(station.metricType)}</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}

OutputDetailModal.propTypes = {
  detail: PropTypes.shape({
    areaName: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    station: stationShape.isRequired
  }),
  factoryName: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired
};
